import Marquee from "react-fast-marquee";

const items = [
  "Websites",
  "E-Commerce",
  "Automation",
  "CRM",
  "Dashboards",
  "SaaS",
  "Booking",
  "Marketplaces",
  "Portals",
  "Security",
  "Cloud",
  "Support",
];

export default function EditorialMarquee() {
  return (
    <section className="relative py-16 lg:py-24 border-y border-[color:var(--border)] overflow-hidden" data-testid="marquee-section">
      <Marquee gradient={false} speed={30} pauseOnHover>
        <div className="marquee-row">
          {items.concat(items).map((t, i) => (
            <div key={i} className="flex items-center gap-24">
              <span className="font-serif italic text-[clamp(3rem,7vw,6rem)] leading-none tracking-tight text-[color:var(--text)]">
                {t}
              </span>
              <span className="w-2.5 h-2.5 rounded-full bg-brand-primary" />
            </div>
          ))}
        </div>
      </Marquee>
    </section>
  );
}
